import { put, call } from 'redux-saga/effects';
import { copyCategoryToCategory,copyMasterCardToClient,aflt_masterRateCardList, aflt_masterRateCardUpdate, getAffiliateChiefBonus, updateAffiliateChiefBonus, getRateCardChiefBonus,  updateRateCardChiefBonus, rateCardList, rateCardUpdate } from '../../../services/settings/affiliates/aflt_masterratecardService';

import * as types from '../../../actions';

export function* aflt_masterratecardListSaga(payload) {  
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(aflt_masterRateCardList, payload);
      yield put({ type: types.MASTER_RATE_CARD_LIST_AFFILIATE_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.MASTER_RATE_CARD_LIST_AFFILIATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
} 

export function* aflt_masterratecardUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(aflt_masterRateCardUpdate, payload); 
    yield put({ type: types.MASTER_RATE_CARD_UPDATE_AFFILIATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.MASTER_RATE_CARD_UPDATE_AFFILIATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* getAffiliateChiefBonusSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER}) 
    const response = yield call(getAffiliateChiefBonus, payload); 
    yield put({ type: types.GET_AFFILIATE_CHEIF_BONUS_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.GET_AFFILIATE_CHEIF_BONUS_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* updateAffiliateChiefBonusSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(updateAffiliateChiefBonus, payload); 
    yield put({ type: types.UPDATE_AFFILIATE_CHEIF_BONUS_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.UPDATE_AFFILIATE_CHEIF_BONUS_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* getRateCardChiefBonusSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER}) 
    const response = yield call(getRateCardChiefBonus, payload); 
    yield put({ type: types.RATECARD_CHEIF_BONUS_GET_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.RATECARD_CHEIF_BONUS_GET_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* updateRateCardChiefBonusSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(updateRateCardChiefBonus, payload); 
    yield put({ type: types.RATECARD_CHEIF_BONUS_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.RATECARD_CHEIF_BONUS_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* copyMasterCardToClientSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(copyMasterCardToClient, payload); 
    yield put({ type: types.COPY_MASTER_CARD_TO_CLIENT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.COPY_MASTER_CARD_TO_CLIENT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
export function* copyCategoryToCategorySaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(copyCategoryToCategory, payload); 
    yield put({ type: types.COPY_CATEGORY_TO_CATEGORY_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.COPY_CATEGORY_TO_CATEGORY_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* rateCardListSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(rateCardList, payload);
    yield put({ type: types.RATE_CARD_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.RATE_CARD_LIST_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
}
} 

export function* rateCardUpdateSaga(payload) { 
try {
  yield put({ type: types.SHOW_LOADER})
  const response = yield call(rateCardUpdate, payload); 
  yield put({ type: types.RATE_CARD_UPDATE_SUCCESS, response })
        
} catch(error) {
  yield put({ type: types.RATE_CARD_UPDATE_ERROR, error });
}finally{
    yield put({ type: types.HIDE_LOADER})
}
}




